module.exports = __webpack_public_path__ + "img/logo.8ba51304.png";